import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';

import DirectDebitMandates from './Pages/DirectDebitMandates';
import PaymentsHome from './Pages/PaymentsHome';
import ScheduledTransfers from './Pages/ScheduledTransfers';
import Transfers from './Pages/Transfers';
import routes from './routes';

export interface PaymentsProps {
  match: {
    url: string;
  };
}

const Payments: FC<PaymentsProps> = () => {
  return (
    <Switch>
      <Route component={PaymentsHome} exact path={routes.root} />
      <Route component={DirectDebitMandates} path={routes.mandates} />
      <Route component={Transfers} path={routes.transfers} />
      <Route
        component={ScheduledTransfers}
        exact
        path={routes.scheduledTransfers}
      />
      <Route
        component={ScheduledTransfers}
        path={routes.scheduledTransferDetails}
      />
    </Switch>
  );
};

export default Payments;
